import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import history from "./history";
import { connectRouter, routerMiddleware } from "connected-react-router";
import { composeWithDevTools } from 'redux-devtools-extension';
import persistState from 'redux-localstorage';

import reducer from "../reducers";

const store = createStore(
  connectRouter(history)(reducer),
  {},
  composeWithDevTools(
    persistState(['user', 'theme', 'document_management']),
    applyMiddleware(routerMiddleware(history)),
    applyMiddleware(thunk),
  ),
);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js